import { render, staticRenderFns } from "./DuplicateListDialog.vue?vue&type=template&id=6813b065"
import script from "./DuplicateListDialog.vue?vue&type=script&lang=js"
export * from "./DuplicateListDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports